import React, { Dispatch, FC, SetStateAction } from "react";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { ThemeBuilderSection } from "../WidgetThemeBuilder/ThemeBuilderSection";
import { SearchWidgetTextThemeBuilder } from "./TextThemeBuilder";
import { WidgetMarginPicker } from "../WidgetThemeBuilder/WidgetMarginPicker";
import { SearchWidgetTextBlockTheme } from "./SearchWidgetTypes";

export interface SearchWidgetTextBlockThemeBuilderProps {
    readonly label: string;
    readonly theme: SearchWidgetTextBlockTheme | undefined;
    readonly defaultTheme: SearchWidgetTextBlockTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<SearchWidgetTextBlockTheme>>;
}

const EMPTY_THEME: SearchWidgetTextBlockTheme = {};

const SearchWidgetTextBlockThemeBuilderInner: FC<SearchWidgetTextBlockThemeBuilderProps> = props => {
    const theme: SearchWidgetTextBlockTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: SearchWidgetTextBlockTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const handleTextChange = useOnChangeChildDispatch("text", onChange);
    const handleMarginChange = useOnChangeChildDispatch("margin", onChange);
    const handlePaddingChange = useOnChangeChildDispatch("padding", onChange);

    return (
        <ThemeBuilderSection heading={props.label} className="widget-text-theme-builder">
            <SearchWidgetTextThemeBuilder key="text" theme={theme.text} defaultTheme={defaultTheme.text} onChange={handleTextChange} />
            <WidgetMarginPicker key="margins" theme={theme.margin} defaultTheme={defaultTheme.margin} onChange={handleMarginChange} />
            <WidgetMarginPicker key="paddings" label="Paddings" theme={theme.padding} defaultTheme={defaultTheme.padding} onChange={handlePaddingChange} />
        </ThemeBuilderSection>
    );
};

export const SearchWidgetTextBlockThemeBuilder = React.memo(SearchWidgetTextBlockThemeBuilderInner);
